import { createStyles } from '@mantine/core';
import { useMemo } from 'react';
import { FindFactionColor } from '../../factionalwarfare/FactionColors.js';
var useStyles = createStyles(function (theme, _ref) {
  var backgroundColor = _ref.backgroundColor,
    _ref$sidebarBackgroun = _ref.sidebarBackgroundColor,
    sidebarBackgroundColor = _ref$sidebarBackgroun === void 0 ? backgroundColor : _ref$sidebarBackgroun,
    blur = _ref.blur;
  var amarr = FindFactionColor("amarr");
  var caldari = FindFactionColor("caldari");
  var gallente = FindFactionColor("gallente");
  var minmatar = FindFactionColor("minmatar");
  var angel = FindFactionColor("angel");
  var guristas = FindFactionColor("guristas");
  return {
    root: {
      width: "100%",
      height: "100%"
    },
    amarr: {
      "--factionColor": amarr,
      "--scrollColor": theme.fn.rgba(amarr, 0.4)
    },
    caldari: {
      "--factionColor": caldari,
      "--scrollColor": theme.fn.rgba(caldari, 0.4)
    },
    gallente: {
      "--factionColor": gallente,
      "--scrollColor": theme.fn.rgba(gallente, 0.4)
    },
    minmatar: {
      "--factionColor": minmatar,
      "--scrollColor": theme.fn.rgba(minmatar, 0.4)
    },
    angel: {
      "--factionColor": angel,
      "--scrollColor": theme.fn.rgba(angel, 0.4)
    },
    guristas: {
      "--factionColor": guristas,
      "--scrollColor": theme.fn.rgba(guristas, 0.4)
    },
    inner: {
      position: "absolute",
      top: "43px",
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 11
    },
    contentCell: {
      maxHeight: "100%",
      height: "100%",
      backgroundColor: backgroundColor
    },
    tableDataOuter: {
      maxHeight: "100%",
      height: "100%"
    },
    tableDataInner: {
      padding: "1rem"
    },
    infoCell: {
      position: "relative",
      backgroundColor: sidebarBackgroundColor,
      backdropFilter: blur ? "blur(".concat(blur, "px)") : void 0,
      "@media (min-width: 1200px)": {
        padding: "45px 20px 20px 20px"
      },
      padding: "0.5rem 1rem"
    },
    fullScreenIcon: {
      position: "absolute",
      top: 5,
      right: 5
    }
  };
});
var useSubStyles = function useSubStyles(_ref2) {
  var sidebarBackgroundColor = _ref2.sidebarBackgroundColor,
    _ref2$blur = _ref2.blur,
    blur = _ref2$blur === void 0 ? 4 : _ref2$blur;
  return useMemo(function () {
    var tabsStyles = {
      root: {
        position: "relative",
        height: "100%",
        zIndex: 1
      },
      tabsList: {
        position: "absolute",
        backgroundColor: sidebarBackgroundColor,
        backdropFilter: blur ? "blur(".concat(blur, "px)") : void 0,
        top: 0,
        left: 0,
        right: 0,
        zIndex: 12,
        justifyContent: "center",
        borderBottom: "2px solid transparent"
      },
      tab: {
        "&[data-active]": {
          borderColor: "var(--factionColor, #1971c2)",
          "@media (hover: hover)": {
            "&:hover": {
              borderColor: "var(--factionColor, #1971c2)"
            }
          }
        }
      },
      tabLabel: {
        fontWeight: 600,
        fontSize: "22px",
        margin: "0 30px"
      },
      panel: {
        paddingBottom: "75%",
        overflow: "hidden"
      }
    };
    var scrollAreaStyles = {
      scrollbar: {
        backgroundColor: "#2B2E2F",
        padding: "0"
      },
      thumb: {
        backgroundColor: "var(--scrollColor, rgba(19, 185, 221, 0.4))",
        borderRadius: 8
      }
    };
    return {
      tabsStyles: tabsStyles,
      scrollAreaStyles: scrollAreaStyles
    };
  }, [sidebarBackgroundColor, blur]);
};
export { useStyles as default, useSubStyles };